exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n.ui-picklist.ui-picklist-responsive .ui-picklist-listwrapper.ui-picklist-listwrapper-nocontrols {\r\n    width: 47% !important;\r\n}\r\n\r\n.ui-picklist.ui-picklist-responsive .ui-picklist-buttons {\r\n    width: 6% !important;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/customers/customers-group.component.css
// module id = 647
// module chunks = 0